import { ReactNode } from "react"
import { AppSidebar } from "@/components/app-sidebar"
import { AppHeader } from "@/components/app-header"
import { AppContent } from "@/components/app-content"

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="app-grid-bg relative flex min-h-screen bg-transparent">
      <div className="hero-orb absolute top-0 right-[8%] h-72 w-72 rounded-full bg-[radial-gradient(circle,_rgba(61,180,142,0.28)_0%,_transparent_70%)]" />
      <div className="hero-orb absolute bottom-[-4rem] left-[18%] h-80 w-80 rounded-full bg-[radial-gradient(circle,_rgba(67,111,173,0.18)_0%,_transparent_72%)]" />
      <AppSidebar />
      <div className="relative flex flex-1 flex-col overflow-hidden pl-24 lg:pl-80">
        <AppHeader />
        <AppContent>{children}</AppContent>
      </div>
    </div>
  )
}
